/* ==========================================================================
   AURA — RELATED PRODUCTS carousel arrows
   Delegated so it keeps working after <product-recommendations> swaps its own
   innerHTML (global.js). Scrolls the track by roughly one viewport of cards.
   ========================================================================== */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-related-prev], [data-related-next]');
    if (!btn) return;

    const root = btn.closest('.aura-related');
    const track = root && root.querySelector('[data-related-track]');
    if (!track) return;

    const isNext = btn.hasAttribute('data-related-next');
    const item = track.querySelector('.aura-related__item');
    const gap = parseFloat(getComputedStyle(track).columnGap) || 20;
    // Scroll by as many whole cards as currently fit (min one).
    const step = item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    const perView = Math.max(1, Math.floor(track.clientWidth / step));
    const distance = step * perView;

    track.scrollBy({ left: isNext ? distance : -distance, behavior: 'smooth' });
  });
})();
